(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[552],{

/***/ 34405:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(35937);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85814:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/imgCompanies.0974565e.png","height":1892,"width":3000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAALVBMVEWDhYdNSUIjLSpfYV1DRkAvLylTV1N0bmqJi41xc3M5Pzt/fXt5enpaVU04Qj6osmKwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVQImQXBhwEAIAgEsXuKCpb9xzUhBqwJtPk62mDZFXknFj4y5dgrlxQfEQ0AwLQXxGcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 96801:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/imgTalent.a3c8c6b4.png","height":1892,"width":3000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAKlBMVEVjX11qamlBPDdPTEotIRpIPDx0cnNQT1E4NS9NSEJuX1daRDlnVk9CMyw8sQh2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVQImQXBBwEAIAzAsO4fwL9dEkQSy7N0iRquuKobz+mxCNlDDcRNPg+NAL3WOrgmAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 35937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AboutUs": function() { return /* binding */ AboutUs; },
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-update-header.tsx
var use_update_header = __webpack_require__(41898);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/utils/constants.ts + 14 modules
var constants = __webpack_require__(68579);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-clean-header.tsx
var use_clean_header = __webpack_require__(90573);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/seo/index.tsx
var seo = __webpack_require__(25352);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/backgrounds/about-us-hero.png
/* harmony default export */ var about_us_hero = ({"src":"/_next/static/media/about-us-hero.aa781381.png","height":5266,"width":3511,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAGFBMVEUsNkQlJi4PFB0eGx0aHykiLz8pMDkXK0GLHldcAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVQImRXEsREAMAwCsQeDvf/GuagQLHds6VGgJNLimRHWHyWmsecBDEMAdzsFb0IAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/about-us/about-us-hero/styles.module.scss
var styles_module = __webpack_require__(44004);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/about-us/about-us-hero/index.tsx





const AboutUsHero = /*#__PURE__*/ (0,react.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (styles_module_default())["section-container"],
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: about_us_hero,
                className: (styles_module_default())["background-image"],
                fill: true,
                sizes: "100vw",
                alt: "People at a table discussing",
                loading: "eager"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: (styles_module_default()).title,
                            children: [
                                "We were born to",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (styles_module_default())["decorated-title"],
                                    children: "reduce intercultural barriers"
                                }),
                                " and to promote thriving work relationships."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (styles_module_default()).subtitle,
                            children: "Olby fosters connections between Brazilian talent and international companies, boosting global tech careers."
                        })
                    ]
                })
            })
        ]
    });
});
/* harmony default export */ var about_us_about_us_hero = ((/* unused pure expression or super */ null && (AboutUsHero)));

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/about-us/video-section/styles.module.scss
var video_section_styles_module = __webpack_require__(84029);
var video_section_styles_module_default = /*#__PURE__*/__webpack_require__.n(video_section_styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/about-us/video-section/index.tsx



const YOUTUBE_LINK = "https://www.youtube.com/embed/HmVKWfYx6kk";
const VideoSection = /*#__PURE__*/ (0,react.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (video_section_styles_module_default())["section-container"],
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (video_section_styles_module_default()).content,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                className: (video_section_styles_module_default()).iframe,
                src: YOUTUBE_LINK,
                title: "Life is made of opportunities",
                allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            })
        })
    });
});
/* harmony default export */ var video_section = ((/* unused pure expression or super */ null && (VideoSection)));

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(75536);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(35463);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 35 modules
var features_animation = __webpack_require__(72834);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 27 modules
var motion_minimal = __webpack_require__(97474);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/backgrounds/we-are-olby.webp
/* harmony default export */ var we_are_olby = ({"src":"/_next/static/media/we-are-olby.99d5148c.webp","height":4024,"width":6048,"blurDataURL":"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACwAQCdASoIAAUAAkA4JQBOgCHfwHkAAP7975RvZl9enwC3TXMk63Da23OcaQAA","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/universe-expansion-frame.svg
var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgUniverseExpansionFrame = function SvgUniverseExpansionFrame(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 1095 1199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_7231_38515)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M703.144 501.457L670.602 697.24H381.826L414.347 501.457H703.144Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/react.createElement("path", {
    d: "M766.824 421.543L707.372 777.152H321.635L381.05 421.543H766.824Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/react.createElement("path", {
    d: "M825.265 334.973L735.828 863.727H251.417L340.799 334.973H825.265Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/react.createElement("path", {
    d: "M888.727 248.398L769.98 950.298H194.492L311.656 248.398H888.727Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/react.createElement("path", {
    d: "M953.94 161.828L809.083 1036.87H126.013L272.521 161.828H953.94Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/react.createElement("path", {
    d: "M1019.14 75.2539L843.506 1123.44H64.0762L239.831 75.2539H1019.14Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/react.createElement("path", {
    d: "M1092.64 2L891.892 1196.7H2.36386L202.989 2H1092.64Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_7231_38515"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 1095,
    height: 1199,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgUniverseExpansionFrame);

/* harmony default export */ var universe_expansion_frame = ("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTA5NSAxMTk5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNzIzMV8zODUxNSkiPgo8cGF0aCBkPSJNNzAzLjE0NCA1MDEuNDU3TDY3MC42MDIgNjk3LjI0SDM4MS44MjZMNDE0LjM0NyA1MDEuNDU3SDcwMy4xNDRaIiBzdHJva2U9IiMyRjQ4NkYiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNNzY2LjgyNCA0MjEuNTQzTDcwNy4zNzIgNzc3LjE1MkgzMjEuNjM1TDM4MS4wNSA0MjEuNTQzSDc2Ni44MjRaIiBzdHJva2U9IiMyRjQ4NkYiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNODI1LjI2NSAzMzQuOTczTDczNS44MjggODYzLjcyN0gyNTEuNDE3TDM0MC43OTkgMzM0Ljk3M0g4MjUuMjY1WiIgc3Ryb2tlPSIjMkY0ODZGIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTg4OC43MjcgMjQ4LjM5OEw3NjkuOTggOTUwLjI5OEgxOTQuNDkyTDMxMS42NTYgMjQ4LjM5OEg4ODguNzI3WiIgc3Ryb2tlPSIjMkY0ODZGIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTk1My45NCAxNjEuODI4TDgwOS4wODMgMTAzNi44N0gxMjYuMDEzTDI3Mi41MjEgMTYxLjgyOEg5NTMuOTRaIiBzdHJva2U9IiMyRjQ4NkYiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMTAxOS4xNCA3NS4yNTM5TDg0My41MDYgMTEyMy40NEg2NC4wNzYyTDIzOS44MzEgNzUuMjUzOUgxMDE5LjE0WiIgc3Ryb2tlPSIjMkY0ODZGIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTEwOTIuNjQgMkw4OTEuODkyIDExOTYuN0gyLjM2Mzg2TDIwMi45ODkgMkgxMDkyLjY0WiIgc3Ryb2tlPSIjMkY0ODZGIiBzdHJva2Utd2lkdGg9IjQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF83MjMxXzM4NTE1Ij4KPHJlY3Qgd2lkdGg9IjEwOTUiIGhlaWdodD0iMTE5OSIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/about-us/an-universe-in-expansion/timeline/index.module.scss
var index_module = __webpack_require__(32400);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/about-us/an-universe-in-expansion/timeline/index.tsx



const ITEM_VARIANTS = {
    start: {
        opacity: 0
    },
    end: {
        opacity: 1,
        transition: {
            type: "spring",
            bounce: 0,
            delay: 0.5
        }
    }
};
const LINE_VARIANTS = {
    start: {
        height: "0%"
    },
    end: {
        height: "100%",
        transition: {
            duration: 1
        }
    }
};
const TimelineItem = (param)=>{
    let { year , description , textAnimate , lineAnimate  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
        features: features_animation/* domAnimation */.H,
        strict: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.div, {
            className: (index_module_default())["timeline-wrapper"],
            animate: textAnimate,
            variants: ITEM_VARIANTS,
            initial: "start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).thread,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (index_module_default()).dot
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.hr, {
                            className: (index_module_default())["vertical-line"],
                            animate: lineAnimate,
                            initial: "start",
                            variants: LINE_VARIANTS
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (index_module_default()).year,
                            children: year
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (index_module_default()).description,
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var timeline = ((/* unused pure expression or super */ null && (TimelineItem)));

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/about-us/an-universe-in-expansion/styles.module.scss
var an_universe_in_expansion_styles_module = __webpack_require__(46842);
var an_universe_in_expansion_styles_module_default = /*#__PURE__*/__webpack_require__.n(an_universe_in_expansion_styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/about-us/an-universe-in-expansion/index.tsx








// Animations
const ANIMATION_PROPS = {
    variants: {
        start: {
            y: "50%",
            opacity: 0.1
        },
        end: {
            y: "0%",
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0
            }
        }
    },
    initial: "start",
    whileInView: "end",
    viewport: {
        once: true,
        amount: 0.6
    }
};
const CONTENT_VARIANTS = {
    start: {
        opacity: 0.1
    },
    end: {
        opacity: 1,
        transition: {
            type: "spring",
            bounce: 0,
            when: "beforeChildren"
        }
    }
};
const AnUniverseInExpansion = /*#__PURE__*/ (0,react.forwardRef)((_, ref)=>{
    const contentControl = (0,use_animation/* useAnimation */._)();
    const firstItem = (0,use_animation/* useAnimation */._)();
    const firstLine = (0,use_animation/* useAnimation */._)();
    const secondItem = (0,use_animation/* useAnimation */._)();
    const secondLine = (0,use_animation/* useAnimation */._)();
    const thirdItem = (0,use_animation/* useAnimation */._)();
    const thirdLine = (0,use_animation/* useAnimation */._)();
    const fourthItem = (0,use_animation/* useAnimation */._)();
    const fourthLine = (0,use_animation/* useAnimation */._)();
    const fifthItem = (0,use_animation/* useAnimation */._)();
    const onEnterView = (0,react.useCallback)(async ()=>{
        await contentControl.start("end");
        await firstItem.start("end");
        firstLine.start("end");
        await secondItem.start("end");
        secondLine.start("end");
        await thirdItem.start("end");
        thirdLine.start("end");
        await fourthItem.start("end");
        fourthLine.start("end");
        fifthItem.start("end");
    }, [
        contentControl,
        fifthItem,
        firstItem,
        firstLine,
        fourthItem,
        fourthLine,
        secondItem,
        secondLine,
        thirdItem,
        thirdLine
    ]);
    const TIMELINE_DATA = (0,react.useMemo)(()=>[
            {
                year: "2018",
                description: "We started as a software development company called Jungle Devs creating digital products with Silicon Valley and NY-based startups. Since day one what set us apart was our mentored-based program for training and upskilling new talent that allowed us to boost our talent careers while delivering value to global companies. ",
                textAnimate: firstItem,
                lineAnimate: firstLine
            },
            {
                year: "2019",
                description: "By focusing on delivering best-in-class software, we organically grew our partner companies' network in the US, and then Canada, the UK, Australia, Poland, and South Africa.",
                textAnimate: secondItem,
                lineAnimate: secondLine
            },
            {
                year: "2020",
                description: "We have already trained over 100 developers to work on international projects with globally distributed teams.",
                textAnimate: thirdItem,
                lineAnimate: thirdLine
            },
            {
                year: "2021",
                description: "We understood that we have had great processes to guide developers on their path to success while working with global companies. However, Brazil's talent pool was much bigger than our initial focus, with many talented individuals looking for such opportunities. We were then acquired by Trybe who partnered with our vision to expand our horizons.",
                textAnimate: fourthItem,
                lineAnimate: fourthLine
            },
            {
                year: "2022",
                description: "On a small scale, we opened up our community and validated a new company model with a selected group of clients. Later on, as Olby, we officially launched our community and dove into this new vision. For talent, we are building a journey that starts with an opportunity and evolves into a career booster. For companies, we're allowing them to do more with engaged talent from Brazil, while we take care of all the hustle.",
                textAnimate: fifthItem
            }
        ], [
        fifthItem,
        firstItem,
        firstLine,
        fourthItem,
        fourthLine,
        secondItem,
        secondLine,
        thirdItem,
        thirdLine
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (an_universe_in_expansion_styles_module_default())["section-container"],
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: we_are_olby,
                className: (an_universe_in_expansion_styles_module_default())["background-image"],
                fill: true,
                sizes: "100vw",
                alt: "Stars in the space"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (an_universe_in_expansion_styles_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
                features: features_animation/* domAnimation */.H,
                strict: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (an_universe_in_expansion_styles_module_default())["section-content"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.h2, {
                            className: (an_universe_in_expansion_styles_module_default()).title,
                            ...ANIMATION_PROPS,
                            children: [
                                "We are ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (an_universe_in_expansion_styles_module_default())["decorated-title"],
                                    children: "Olby"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.p, {
                            className: (an_universe_in_expansion_styles_module_default()).description,
                            ...ANIMATION_PROPS,
                            children: "Just like the universe, we are in constant movement, expanding, discovering the space that goes beyond what is known today."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                            className: (an_universe_in_expansion_styles_module_default())["timeline-container"],
                            onViewportEnter: onEnterView,
                            initial: "start",
                            animate: contentControl,
                            variants: CONTENT_VARIANTS,
                            children: TIMELINE_DATA.map((param)=>/*#__PURE__*/ {
                                let { year , description , textAnimate , lineAnimate  } = param;
                                return (0,jsx_runtime.jsx)(TimelineItem, {
                                    year: year,
                                    description: description,
                                    textAnimate: textAnimate,
                                    lineAnimate: lineAnimate
                                }, year);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                            className: (an_universe_in_expansion_styles_module_default()).frame
                        })
                    ]
                })
            })
        ]
    });
});
/* harmony default export */ var an_universe_in_expansion = ((/* unused pure expression or super */ null && (AnUniverseInExpansion)));

;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/backgrounds/values-aim.webp
/* harmony default export */ var values_aim = ({"src":"/_next/static/media/values-aim.00905038.webp","height":464,"width":1216,"blurDataURL":"data:image/webp;base64,UklGRjAAAABXRUJQVlA4ICQAAACQAQCdASoIAAMAAkA4JZwAAudZtgAA/voD1CGkl7Cvu2RnwAA=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/backgrounds/values-care.webp
/* harmony default export */ var values_care = ({"src":"/_next/static/media/values-care.9aa1aa21.webp","height":520,"width":1216,"blurDataURL":"data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACwAQCdASoIAAMAAkA4JZwAAxZhCvFYAP77mrwOBHlEeqHuJeAAAA==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/backgrounds/values-commit.webp
/* harmony default export */ var values_commit = ({"src":"/_next/static/media/values-commit.6884a45e.webp","height":520,"width":1216,"blurDataURL":"data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACQAQCdASoIAAMAAkA4JZwAAudHxMAA/vuTu0sgdznx7Nr+YUgAAA==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/backgrounds/values-trust.webp
/* harmony default export */ var values_trust = ({"src":"/_next/static/media/values-trust.546b37e5.webp","height":464,"width":1216,"blurDataURL":"data:image/webp;base64,UklGRjYAAABXRUJQVlA4ICoAAACQAQCdASoIAAMAAkA4JZQAAudQDBAA/vshInTIAHJyUorMmd8x6BxwAAA=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/backgrounds/values-truth.webp
/* harmony default export */ var values_truth = ({"src":"/_next/static/media/values-truth.36f3ba6f.webp","height":464,"width":1216,"blurDataURL":"data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACQAQCdASoIAAMAAkA4JZQAAudZt7gA/vqaD1418VIv/wTTQ/hAAA==","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/about-us/our-values/index.module.scss
var our_values_index_module = __webpack_require__(53447);
var our_values_index_module_default = /*#__PURE__*/__webpack_require__.n(our_values_index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/about-us/our-values/index.tsx










// Animations
const our_values_ANIMATION_PROPS = {
    variants: {
        start: {
            y: "50%",
            opacity: 0.1
        },
        end: {
            y: "0%",
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0
            }
        }
    },
    initial: "start",
    whileInView: "end",
    viewport: {
        once: true
    }
};
const CARDS = [
    {
        title: {
            highlight: "When the truth is told,",
            text: " transparency unfolds"
        },
        description: "We have a safe and open environment that allows transparent communication to flourish clearly and fluidly.",
        picture: values_truth
    },
    {
        title: {
            highlight: "Aim high,",
            text: " beyond the sky"
        },
        description: "We are in constant movement. That’s why we think big and see new challenges as a form of continuous growth.",
        picture: values_aim
    },
    {
        title: {
            highlight: "Between us,",
            text: " there is trust"
        },
        description: "We give freedom to people to perform their best because we trust in one another. We genuinely embrace the sense of confidence.",
        picture: values_trust
    },
    {
        title: {
            highlight: "We commit,",
            text: " we don't quit"
        },
        description: "We take responsibility for what we commit to, from beginning to end. We charge ourselves with passion and energy, and never take the easy way out.",
        picture: values_commit
    },
    {
        title: {
            highlight: "We take care,",
            text: " no matter where"
        },
        description: "We think collectively and work towards a common goal. That’s why we always have each other’s back, even from miles apart. As a team, we always aim for mutual success.",
        picture: values_care
    }
];
const AboutUsOurValues = /*#__PURE__*/ (0,react.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: ref,
        className: (our_values_index_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
            features: features_animation/* domAnimation */.H,
            strict: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (our_values_index_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.h2, {
                        className: (our_values_index_module_default()).title,
                        ...our_values_ANIMATION_PROPS,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (our_values_index_module_default()).highlight,
                                children: "Our"
                            }),
                            " values"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.p, {
                        className: (our_values_index_module_default()).description,
                        ...our_values_ANIMATION_PROPS,
                        children: "Values make our culture tangible. They guide Olbers on their journeys, to fly higher and move further, day by day."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (our_values_index_module_default())["cards-wrapper"],
                        children: CARDS.map((card)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.div, {
                                className: (our_values_index_module_default()).card,
                                ...our_values_ANIMATION_PROPS,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: card.picture,
                                        alt: "background",
                                        fill: true,
                                        className: (our_values_index_module_default())["background-image"]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: (our_values_index_module_default())["card-title"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (our_values_index_module_default()).highlight,
                                                children: card.title.highlight
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            card.title.text
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (our_values_index_module_default())["card-description"],
                                        children: card.description
                                    })
                                ]
                            }))
                    })
                ]
            })
        })
    });
});

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/assets/backgrounds/imgTalent.png
var imgTalent = __webpack_require__(96801);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/assets/backgrounds/imgCompanies.png
var imgCompanies = __webpack_require__(85814);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(10912);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/about-us/the-trust-needed/index.module.scss
var the_trust_needed_index_module = __webpack_require__(13256);
var the_trust_needed_index_module_default = /*#__PURE__*/__webpack_require__.n(the_trust_needed_index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/about-us/the-trust-needed/index.tsx









const ANIMATIONS = {
    TALENT: "TALENT",
    COMPANY: "COMPANY"
};
// Animations
const the_trust_needed_ANIMATION_PROPS = {
    variants: {
        start: {
            y: "50%",
            opacity: 0.1
        },
        end: {
            y: "0%",
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0
            }
        }
    },
    initial: "start",
    whileInView: "end",
    viewport: {
        once: true
    }
};
const AboutUsTheTrustNeeded = /*#__PURE__*/ (0,react.forwardRef)((_, ref)=>{
    const [currentAnimation, setCurrentAnimation] = (0,react.useState)(undefined);
    const onTalentAnimation = (0,react.useCallback)(()=>{
        setCurrentAnimation(ANIMATIONS.TALENT);
    }, []);
    const onCompanyAnimation = (0,react.useCallback)(()=>{
        setCurrentAnimation(ANIMATIONS.COMPANY);
    }, []);
    const onRemoveAnimation = (0,react.useCallback)(()=>{
        setCurrentAnimation(undefined);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: ref,
        className: (the_trust_needed_index_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: imgTalent/* default */.Z,
                className: classnames_default()((the_trust_needed_index_module_default())["background-image"], (the_trust_needed_index_module_default())["talent-background-image"], {
                    [(the_trust_needed_index_module_default())["image-visible"]]: currentAnimation === ANIMATIONS.TALENT
                }),
                alt: "Person smiling while working with a team in a desk with personal computers",
                fill: true,
                sizes: "100vw"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: imgCompanies/* default */.Z,
                className: classnames_default()((the_trust_needed_index_module_default())["background-image"], (the_trust_needed_index_module_default())["companies-background-image"], {
                    [(the_trust_needed_index_module_default())["image-visible"]]: currentAnimation === ANIMATIONS.COMPANY
                }),
                alt: "Person smiling while closing a deal by handshaking another person",
                fill: true,
                sizes: "100vw"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
                features: features_animation/* domAnimation */.H,
                strict: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (the_trust_needed_index_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.h2, {
                            className: (the_trust_needed_index_module_default()).title,
                            ...the_trust_needed_ANIMATION_PROPS,
                            children: [
                                "The trust needed for a",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (the_trust_needed_index_module_default()).highlight,
                                    children: "successful connection."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.p, {
                            className: (the_trust_needed_index_module_default()).description,
                            ...the_trust_needed_ANIMATION_PROPS,
                            children: "We create a universe for talent and companies that seek each other out and find one another. We are not a “hire-only“ company, we are on this path together, hand in hand, on a continuous road."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.p, {
                            className: (the_trust_needed_index_module_default()).text,
                            ...the_trust_needed_ANIMATION_PROPS,
                            children: [
                                "Let's ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (the_trust_needed_index_module_default()).highlight,
                                    children: "explore"
                                }),
                                " your new journey"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            href: "/for-talent",
                            className: classnames_default()((the_trust_needed_index_module_default())["talent-button"], (the_trust_needed_index_module_default()).button),
                            onMouseEnter: onTalentAnimation,
                            onFocus: onTalentAnimation,
                            onMouseLeave: onRemoveAnimation,
                            onBlur: onRemoveAnimation,
                            variant: currentAnimation === ANIMATIONS.COMPANY ? "opacity" : "highlight",
                            prefetch: false,
                            children: "for talent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            href: "/for-companies",
                            onMouseEnter: onCompanyAnimation,
                            onFocus: onCompanyAnimation,
                            onMouseLeave: onRemoveAnimation,
                            onBlur: onRemoveAnimation,
                            variant: currentAnimation === ANIMATIONS.TALENT ? "opacity" : "highlight",
                            className: (the_trust_needed_index_module_default()).button,
                            prefetch: false,
                            children: "for companies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            href: "/for-talent",
                            className: classnames_default()((the_trust_needed_index_module_default())["talent-button"], (the_trust_needed_index_module_default())["mobile-button"]),
                            variant: "highlight",
                            size: "medium",
                            prefetch: false,
                            children: "for talent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            href: "/for-companies",
                            variant: "highlight",
                            className: (the_trust_needed_index_module_default())["mobile-button"],
                            size: "medium",
                            prefetch: false,
                            children: "for companies"
                        })
                    ]
                })
            })
        ]
    });
});

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/from-our-blog-section/index.tsx
var from_our_blog_section = __webpack_require__(50096);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/layouts/website-layout/index.tsx + 9 modules
var website_layout = __webpack_require__(46087);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/graphql/website/blog-post-fragments.generated.ts
var blog_post_fragments_generated = __webpack_require__(71285);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(60431);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/custom-fetcher/index.ts
var custom_fetcher = __webpack_require__(97885);
;// CONCATENATED MODULE: ../../libs/data-access/src/lib/graphql/website/get-website-about-us-page.generated.ts
/* eslint-disable */ // @ts-nocheck



const GetWebsiteAboutUsPageDocument = /*#__PURE__*/ "\n    query GetWebsiteAboutUsPage($input: WebsiteAboutUsPageQueryArgs!) {\n  getWebsiteAboutUsPage(input: $input) {\n    data {\n      id\n      posts {\n        post {\n          article\n          resume\n          slug\n          title\n          readingTime\n          ...GetBlogPostBySlugAuthorFragment\n          ...GetBlogPostBySlugImageFragment\n          ...GetBlogPostBySlugTagsFragment\n          ...GetBlogPostBySlugSeoFragment\n          ...GetBlogPostBySlugCategoryFragment\n        }\n      }\n    }\n  }\n}\n    ".concat(blog_post_fragments_generated/* GetBlogPostBySlugAuthorFragmentFragmentDoc */.s_, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugImageFragmentFragmentDoc */.FD, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugTagsFragmentFragmentDoc */.E6, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugSeoFragmentFragmentDoc */.mW, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugCategoryFragmentFragmentDoc */.Wj);
const useGetWebsiteAboutUsPageQuery = (variables, options)=>(0,index_production.useQuery)([
        "GetWebsiteAboutUsPage",
        variables
    ], (0,custom_fetcher/* customFetcher */.k)(GetWebsiteAboutUsPageDocument, variables), options);
useGetWebsiteAboutUsPageQuery.getKey = (variables)=>[
        "GetWebsiteAboutUsPage",
        variables
    ];
const useInfiniteGetWebsiteAboutUsPageQuery = (variables, options)=>{
    var _pageParam;
    return (0,index_production.useInfiniteQuery)([
        "GetWebsiteAboutUsPage.infinite",
        variables
    ], (metaData)=>(0,custom_fetcher/* customFetcher */.k)(GetWebsiteAboutUsPageDocument, {
            ...variables,
            ...(_pageParam = metaData.pageParam) !== null && _pageParam !== void 0 ? _pageParam : {}
        })(), options);
};
useInfiniteGetWebsiteAboutUsPageQuery.getKey = (variables)=>[
        "GetWebsiteAboutUsPage.infinite",
        variables
    ];
useGetWebsiteAboutUsPageQuery.fetcher = (variables, options)=>(0,custom_fetcher/* customFetcher */.k)(GetWebsiteAboutUsPageDocument, variables, options);

// EXTERNAL MODULE: ../../libs/data-access/src/lib/types.generated.ts
var types_generated = __webpack_require__(9432);
// EXTERNAL MODULE: ../../libs/utils/src/lib/website/website-strapi.ts
var website_strapi = __webpack_require__(82185);
;// CONCATENATED MODULE: ./pages/about-us/index.tsx





const SEO = {
    title: "About us // Olby",
    description: "We were born to reduce intercultural barriers and to promote thriving work relationships."
};
const AboutUs = ()=>{
    const heroSection = (0,react.useRef)(null);
    const videoSection = (0,react.useRef)(null);
    const anUniverseInExpansionRef = (0,react.useRef)(null);
    const ourValuesRef = (0,react.useRef)(null);
    const theTrustNeededRef = (0,react.useRef)(null);
    const fromOurBlogRef = (0,react.useRef)(null);
    (0,use_update_header/* useUpdateHeader */.G)(heroSection, constants/* HEADER_THEMES.BLURRED */._.BLURRED);
    (0,use_update_header/* useUpdateHeader */.G)(videoSection, constants/* HEADER_THEMES.BLURRED */._.BLURRED);
    (0,use_update_header/* useUpdateHeader */.G)(anUniverseInExpansionRef, constants/* HEADER_THEMES.BLURRED */._.BLURRED);
    (0,use_update_header/* useUpdateHeader */.G)(ourValuesRef, constants/* HEADER_THEMES.BLURRED */._.BLURRED);
    (0,use_update_header/* useUpdateHeader */.G)(theTrustNeededRef, constants/* HEADER_THEMES.BLURRED */._.BLURRED);
    (0,use_update_header/* useUpdateHeader */.G)(fromOurBlogRef, constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND);
    (0,use_clean_header/* useCleanHeader */._)();
    const { data  } = useGetWebsiteAboutUsPageQuery({
        input: {
            locale: types_generated/* Locale.En */.go.En
        }
    });
    const posts = (0,react.useMemo)(()=>{
        var ref, ref1, ref2;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.getWebsiteAboutUsPage) === null || ref === void 0 ? void 0 : ref.data)) {
            return [];
        }
        const list = (ref2 = data === null || data === void 0 ? void 0 : (ref1 = data.getWebsiteAboutUsPage) === null || ref1 === void 0 ? void 0 : ref1.data.posts) === null || ref2 === void 0 ? void 0 : ref2.map((param)=>{
            let { post  } = param;
            return post;
        });
        const formattedArticles = (0,website_strapi/* websiteFormatArticleList */.o)(list || []);
        return formattedArticles;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* WebsiteSeo */.P, {
                seo: SEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsHero, {
                ref: heroSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSection, {
                ref: videoSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnUniverseInExpansion, {
                ref: anUniverseInExpansionRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsOurValues, {
                ref: ourValuesRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsTheTrustNeeded, {
                ref: theTrustNeededRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(from_our_blog_section/* FromOurBlogSection */.f, {
                posts: posts,
                ref: fromOurBlogRef
            })
        ]
    });
};
/* harmony default export */ var about_us = (AboutUs);
AboutUs.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(website_layout/* WebsiteLayout */.CG, {
        shouldChangeBgColor: true,
        children: page
    });
};


/***/ }),

/***/ 97885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ customFetcher; }
/* harmony export */ });
const customFetcher = (query, variables, options)=>{
    return async ()=>{
        const NEXT_PUBLIC_API_URL = "https://platform-api.olby.com/graphql";
        const res = await fetch(NEXT_PUBLIC_API_URL || "https://platform-api.olby.com/graphql", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Accept: "application/json",
                ...options
            },
            body: JSON.stringify({
                query,
                variables
            })
        });
        const json = await res.json();
        if (json.errors) {
            const errors = json.errors[0];
            throw errors;
        }
        return json.data;
    };
};


/***/ }),

/***/ 10912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ CTAButton; },
  "Z": function() { return /* binding */ components_button; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/src/hooks/use-event-tracking.tsx + 4 modules
var use_event_tracking = __webpack_require__(43287);
// EXTERNAL MODULE: ../../libs/utils/src/lib/amplitude/index.tsx
var amplitude = __webpack_require__(67071);
// EXTERNAL MODULE: ../../libs/utils/src/lib/helpers.ts
var helpers = __webpack_require__(44386);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/cta-arrow.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCtaArrow = function SvgCtaArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.16327 15.5L6.35957 13.7887L11.0943 9.25744H0V6.74256H11.0943L6.35957 2.21875L8.16327 0.5L16 8L8.16327 15.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCtaArrow);

/* harmony default export */ var cta_arrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMTYzMjcgMTUuNUw2LjM1OTU3IDEzLjc4ODdMMTEuMDk0MyA5LjI1NzQ0SDBWNi43NDI1NkgxMS4wOTQzTDYuMzU5NTcgMi4yMTg3NUw4LjE2MzI3IDAuNUwxNiA4TDguMTYzMjcgMTUuNVoiLz4KPC9zdmc+Cg==");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/button/index.module.scss
var index_module = __webpack_require__(8579);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/button/index.tsx







const CTAButton = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { className ="" , href , variant ="highlight" , size ="large" , children , trackingIdentifier , prefetch , isExternal =false , ...rest } = param;
    const classes = classnames_default()((index_module_default()).link, (index_module_default())[variant], (index_module_default())[size], className);
    const innerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>innerRef.current);
    (0,use_event_tracking/* useClickEventTracking */.M)(innerRef, amplitude/* AmplitudeContext */.Lq, "website_button_click", {
        id: trackingIdentifier
    });
    const formattedUrl = isExternal ? href : (0,helpers/* formatUrl */.CN)(href);
    const renderChildren = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (index_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (index_module_default())["arrow-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                        className: (index_module_default()).icon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (index_module_default())["button-label"],
                    children: children
                })
            ]
        });
    }, [
        children
    ]);
    if ((0,helpers/* isExternalUrl */.xf)(href) || isExternal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: formattedUrl,
            className: classes,
            ref: innerRef,
            ...rest,
            children: renderChildren
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: formattedUrl,
        prefetch: prefetch,
        className: classes,
        ref: innerRef,
        ...rest,
        children: renderChildren
    });
});
/* harmony default export */ var components_button = (CTAButton);


/***/ }),

/***/ 50096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FromOurBlogSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79544);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _blog_article_list__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34792);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);





const FromOurBlogSection = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { posts  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["article-section"]),
        ref: ref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "From our blog"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().button),
                href: "/blog",
                size: "large",
                prefetch: false,
                children: "Find more articles"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_blog_article_list__WEBPACK_IMPORTED_MODULE_4__/* .ArticleList */ .w, {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["article-list"]),
                posts: posts,
                hideThirdCard: true
            })
        ]
    });
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (FromOurBlogSection)));


/***/ }),

/***/ 44004:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-container":"styles_section-container__G6Npz","theme--light":"styles_theme--light__GYC68","theme--dark":"styles_theme--dark__ilJ4v","background-image":"styles_background-image__tZi9y","overlay":"styles_overlay__ZuteY","wrapper":"styles_wrapper__Lxogl","content":"styles_content__hJRUP","title":"styles_title__QVnaD","decorated-title":"styles_decorated-title__gVIkd","subtitle":"styles_subtitle__9mR1Z","fade-in-up":"styles_fade-in-up__H_5Wp","fade-in-opacity":"styles_fade-in-opacity__yKDHJ","fade-in-up-opacity":"styles_fade-in-up-opacity__w5_IM","fade-out-opacity":"styles_fade-out-opacity__CiyZy","fade-out-left":"styles_fade-out-left__V2xxz"};

/***/ }),

/***/ 46842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-container":"styles_section-container__vh2M9","theme--light":"styles_theme--light__ncM2H","theme--dark":"styles_theme--dark__1lAHv","background-image":"styles_background-image__OPpfn","overlay":"styles_overlay__L57OO","section-content":"styles_section-content__O5at0","title":"styles_title__FUcVB","decorated-title":"styles_decorated-title__JnW8c","description":"styles_description__mIAqn","timeline-container":"styles_timeline-container__KXRqG","frame":"styles_frame__dafAs","fade-in-up":"styles_fade-in-up__9v_uX","fade-in-opacity":"styles_fade-in-opacity__DG8I2","fade-in-up-opacity":"styles_fade-in-up-opacity__UsO2A","fade-out-opacity":"styles_fade-out-opacity__LJhHn","fade-out-left":"styles_fade-out-left__17Ek1"};

/***/ }),

/***/ 32400:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"timeline-wrapper":"timeline_timeline-wrapper__tc6_c","vertical-line":"timeline_vertical-line__uK40Y","content":"timeline_content__70IJN","thread":"timeline_thread__pADEv","dot":"timeline_dot__UlbM7","theme--light":"timeline_theme--light__BdXP4","theme--dark":"timeline_theme--dark__ZtdEi","year":"timeline_year___tiD0","description":"timeline_description__1JgNn","fade-in-up":"timeline_fade-in-up__CxDfh","fade-in-opacity":"timeline_fade-in-opacity__L9icb","fade-in-up-opacity":"timeline_fade-in-up-opacity__cLiVI","fade-out-opacity":"timeline_fade-out-opacity__bUkS8","fade-out-left":"timeline_fade-out-left__Y3bTO"};

/***/ }),

/***/ 53447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"our-values_wrapper__VtgUf","content":"our-values_content__KySWa","title":"our-values_title__u2x7E","theme--light":"our-values_theme--light__wimQ6","theme--dark":"our-values_theme--dark__N0Dcj","description":"our-values_description__81WXB","cards-wrapper":"our-values_cards-wrapper__wvj6w","card":"our-values_card__I5dHd","background-image":"our-values_background-image__cDPNg","card-title":"our-values_card-title__9Q8T6","card-description":"our-values_card-description__oMO9y","highlight":"our-values_highlight__hO8Nr","fade-in-up":"our-values_fade-in-up__WsQxC","fade-in-opacity":"our-values_fade-in-opacity__K7mBO","fade-in-up-opacity":"our-values_fade-in-up-opacity__fmpgB","fade-out-opacity":"our-values_fade-out-opacity__Y2sB1","fade-out-left":"our-values_fade-out-left__XUHoD"};

/***/ }),

/***/ 13256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"the-trust-needed_wrapper___3Auj","background-image":"the-trust-needed_background-image__U8Htq","talent-background-image":"the-trust-needed_talent-background-image__VtOPz","companies-background-image":"the-trust-needed_companies-background-image__tazbO","image-visible":"the-trust-needed_image-visible__lnP_g","content":"the-trust-needed_content__StCD_","theme--light":"the-trust-needed_theme--light__mmtBI","theme--dark":"the-trust-needed_theme--dark__IdffW","title":"the-trust-needed_title__eGxIw","highlight":"the-trust-needed_highlight__Ch_UH","description":"the-trust-needed_description__AP6Sk","text":"the-trust-needed_text__7R8Vt","talent-button":"the-trust-needed_talent-button__Hw22J","button":"the-trust-needed_button__Un3Q7","mobile-button":"the-trust-needed_mobile-button__r_KSd","fade-in-up":"the-trust-needed_fade-in-up__4bWW5","fade-in-opacity":"the-trust-needed_fade-in-opacity___Bey_","fade-in-up-opacity":"the-trust-needed_fade-in-up-opacity__eD7hs","fade-out-opacity":"the-trust-needed_fade-out-opacity__Qiek2","fade-out-left":"the-trust-needed_fade-out-left__KLFhp"};

/***/ }),

/***/ 84029:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-container":"styles_section-container__E7lWl","theme--light":"styles_theme--light__k47ho","theme--dark":"styles_theme--dark__Wmlht","content":"styles_content__4z6nh","iframe":"styles_iframe__1rWQa","fade-in-up":"styles_fade-in-up__ZNr99","fade-in-opacity":"styles_fade-in-opacity__YRPdm","fade-in-up-opacity":"styles_fade-in-up-opacity__Z_Pn0","fade-out-opacity":"styles_fade-out-opacity__sgPMk","fade-out-left":"styles_fade-out-left__Onc8W"};

/***/ }),

/***/ 8579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"button_link__VCdDw","content":"button_content__ww7LJ","arrow-wrapper":"button_arrow-wrapper__D7KzQ","button-label":"button_button-label__2vBy5","large":"button_large__QhZHB","icon":"button_icon__ix2fV","medium":"button_medium__69Qyj","highlight":"button_highlight__5uvSX","theme--light":"button_theme--light__A2fZm","theme--dark":"button_theme--dark__NiIj7","primary":"button_primary__r9bak","secondary":"button_secondary__nR_xE","white":"button_white__Ln1lX","opacity":"button_opacity__zewbz","fade-in-up":"button_fade-in-up__4Yakx","fade-in-opacity":"button_fade-in-opacity__uiUG0","fade-in-up-opacity":"button_fade-in-up-opacity__CjxjG","fade-out-opacity":"button_fade-out-opacity__U5xnx","fade-out-left":"button_fade-out-left__QoJqj"};

/***/ }),

/***/ 12601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article-section":"styles_article-section__suz_J","title":"styles_title__KMHMh","button":"styles_button__Ze3uu","article-list":"styles_article-list__ZdsOV","fade-in-up":"styles_fade-in-up___5bZo","fade-in-opacity":"styles_fade-in-opacity__YCvaL","fade-in-up-opacity":"styles_fade-in-up-opacity__AmfuJ","fade-out-opacity":"styles_fade-out-opacity__sAnwg","fade-out-left":"styles_fade-out-left____nNW"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,577,196,934,559,735,857,774,888,179], function() { return __webpack_exec__(34405); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);